import { compose } from 'underscore';
import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { mergeStyles } from '@bingads-webui-campaign-react/common-styles';
import { HotelAdGroupBase, scenarios } from './shared';
import { sharedStyles } from './style';

const getStyles = (_, theme) => ({
  ...mergeStyles(
    { theme },
    sharedStyles
  ),
});

export const HotelAdGroupSettings = compose(
  withI18nConsumer,
  WrappedComponent => withDefaultStyles(WrappedComponent, getStyles)
)(props => (<HotelAdGroupBase {...props} scenario={scenarios.settings} />));
